'use client';

import { cn } from '@/styles/utils';
import { SideBannerButton } from '../molecules/SideBannerButton';

interface SideBannerProps {
  position: 'left' | 'right';
  className?: string;
}

export function SideBanner({ position, className }: SideBannerProps) {
  const leftSideBannerItems = [
    { label: '창고지도', href: '/warehouses', src: '/images/warehouse.svg', requiresAuth: true },
    { label: '오퍼계산', href: '/offer-calculator', src: '/images/offer-calculator.svg', requiresAuth: true },
    { label: '통관환율', href: '/currency', src: '/images/currency.svg', requiresAuth: true },
    { label: '검역현황', href: '/livestock_import', src: '/images/livestock_import.svg', requiresAuth: true },
  ]

  const rightSideBannerItems = [
    { label: '채권추심', href: '/bond-banner', src: '/images/banner/side_banner1.png', requiresAuth: false },
    { label: 'EZ-PAY', href: '/ez-pay', src: '/images/banner/side_banner2.png', requiresAuth: false },
  ]

  return (
    <div
      className={cn(
        'w-27 flex-col absolute top-0 hidden lg:flex',
        position === 'left'
          ? 'bg-white rounded-lg shadow-lg p-1.5 -left-29'
          : '-right-29',
        className
      )}
    >

      {position === 'left' && (
        <>
          <span className="body-16b text-(--secondary-700) text-center mt-1.5 mb-3">추천정보</span>
          {leftSideBannerItems.map((item, index) => (
            <SideBannerButton
              key={item.label}
              variant="button"
              isLast={index === leftSideBannerItems.length - 1}
              label={item.label}
              href={item.href}
              src={item.src}
              requiresAuth={item.requiresAuth}
            />
          ))}
        </>
      )}

      {position === 'right' && (
        <>
          {rightSideBannerItems.map((item, index) => (
            <SideBannerButton
              key={item.label}
              variant="image"
              isLast={index === rightSideBannerItems.length - 1}
              label={item.label}
              href={item.href}
              src={item.src}
              requiresAuth={item.requiresAuth}
              target="_blank"
            />
          ))}
        </>
      )}
    </div >
  );
}